
import { VodDetail, VodSignalRStatus } from '@/entities/VodDetail';
import { Component, Prop, toNative, Vue, Watch } from 'vue-facing-decorator';
import VideoPlayer from '@/components/Common/VideoPlayer.vue';
import moment from 'moment-timezone';
import ModalPopup from '@/components/Common/ModalPopup.vue';
import { StoreHelper } from '@/store/StoreHelper';
import { BrowserSettingsInfo } from '@/entities/BrowserSettingsInfo';
import {SignalRModelRequest} from '@/signalRRequest/SignalRModelRequest';
import { CustomCategorySignalRModel } from '@/signalRRequest/CustomCategory/CustomCategorySignalRModel';
import { AppRequestInfo } from '@/entities/AppRequestInfo';
import VirtualMeetingtypeParentEnum from '@/entities/VirtualMeetingType';
import VirtualMeetingEnums from '@/enums/VirtualMeetingEnums';
import VodTypeEnums from '@/enums/VodTypeEnums';
import { VodBaseRenderModel } from '@/entities/FactoryPattern/Vod/VodBaseRenderModel';
import VodModuleTypeEnum from '@/enums/VodModuleTypeEnum';
import { ProgramSignalRModel } from '@/signalRRequest/Program/ProgramSignalRModel';
import { Store, Root, FetchData } from '@/main';
import VodMuxVideoData from '@/entities/Emits/Common/VodMuxVideoData';

@Component({
  components: {
    VideoPlayer,
    ModalPopup,
  },
})
class VideoOnDemandComponent extends Vue {
  @Prop() private selectedVodBaseClasss?: VodBaseRenderModel;
  @Prop() private vonageThresholdLimitReached?: boolean;
  // #region Variables
  private isAddVideoWarningVisible = false;
  private isVideoDetailsVisible = false;
  private videoPlayerVisible = false;
  private isCurrentUserMe = false;
  private missingImage: string = require('@/assets/Images/ImageMissing.png');
  private noThumbnailImage: string = require('@/assets/Images/Nothumbnail.png');
  private uploadingImage: string = require('@/assets/Images/Uploading.png');
  private processingImage: string = require('@/assets/Images/Processinge.png');
  private ErrorImage: string = require('@/assets/Images/ErrorOccuered.png');
  private DeletedImage: string = require('@/assets/Images/videoisdeleted.png');
  private manageIcon = require('@/assets/Images/three-dot-icon.svg');
  private isIEbrowser = false;
  private dateFormat: Intl.DateTimeFormat = new Intl.DateTimeFormat();
  private storeHelper: StoreHelper = new StoreHelper(Store);
  private timeZones: string =
    this.storeHelper.GetActiveEventIanaTimeZoneFromStore();
  private addVideoCheckbox = false;
  private latestVideoStatus = '';
  private VodDeleteVideo = 'VodDeleteVideo';
  private RtmpDeleteVideo = 'RtmpDeleteVideo';
  private VonageMUXDeleteVideo = 'VonageMUXDeleteVideo';
  private videoDuration = '0';
  private videoDurationNumber = '0';
  private publishDateE: any = new Date();
  // modal popup
  private modalPopupVisible = false;
  private showCloseButton = true;
  private modalPopupHeader = '';
  private modalPopupContent = '';
  private modalPopupHeading = '';
  private showSectionModalPopup = '';
  private modalPopupShowCancelButton = true;
  private modalPopupCancelButtonText = '';
  private modalPopupConfirmButtonText = '';
  private isActive = false;
  private scheduledPublishedOn = false;
  private PublishedOn = true;
  private localViewCount = 0;
  private isVideoToBePlayed = false;
  private currentWebHookEvent?: VodSignalRStatus | null;
  private isManageBtnVisible = false;
  private isDisable = false;
  public get virtualMeetingEnum(): typeof VirtualMeetingtypeParentEnum {
    return VirtualMeetingtypeParentEnum;
  }
  private localSubModuleType = 0;
  private UploadRecordedOnLabel = '';
  private localSelectedVodBaseClass: VodBaseRenderModel =
    VodBaseRenderModel.createEmpty();
  private localLinkedProgramLoading = true;
  private loadingImage: string = require('@/assets/Images/loading.png');
  private moduleType = '';
  // #endregion
  private created() {
    if (
      navigator.appName === 'Microsoft Internet Explorer' ||
      !!(
        navigator.userAgent.match(/Trident/) ||
        navigator.userAgent.match(/rv:11/)
      )
    ) {
      this.isIEbrowser = true;
    }
  }
  private mounted() {
    if(this.selectedVodBaseClasss !== null && this.selectedVodBaseClasss !== undefined) {
      this.moduleType = this.selectedVodBaseClasss.Moduletype;
      // set selected vod base class object to local object
      this.localSelectedVodBaseClass = Object.assign({}, this.selectedVodBaseClasss);
    }
    // disable checkbox, if Meetapp live meeting has passed
    Root.on(
      'virtual-meeting-meetapp-live-analytics-available',
      (val: boolean) => {
        this.isDisable = val ;
      },
    );
    // set submodule type in local variable
    this.localSubModuleType = this.localSelectedVodBaseClass.SubModuleType;
    this.setDefaultDisplayDates(self);
    // this.getUploadUlr();

    // Check submodule type, set video information heading and show hide analytics button

    if (
      this.localSubModuleType === this.virtualMeetingEnum.ProfessionalStreaming
    ) {
      this.localSelectedVodBaseClass.SubModuleTypeValue =
        VirtualMeetingEnums.RTMPString;
      this.UploadRecordedOnLabel = this.$t(
        'VirtualMeetings.RecordedOn',
      ).toString();
      Root.emit(
        'virtual-meeting-meetapp-live-analytics-available',
        true,
      );
    } else if (
      this.localSubModuleType === this.virtualMeetingEnum.MeetAppLive &&
      this.localSelectedVodBaseClass.SubModuleTypeValue ===
        VirtualMeetingEnums.VonageMUX
    ) {
      // when we have vonageMux virtualmeeting type
      this.localSelectedVodBaseClass.SubModuleTypeValue =
        VirtualMeetingEnums.VonageMUX;
      this.UploadRecordedOnLabel = this.$t(
        'VirtualMeetings.RecordedOn',
      ).toString();
      Root.emit(
        'virtual-meeting-meetapp-live-analytics-available',
        true,
      );
    } else {
      // for MUX
      this.localSelectedVodBaseClass.SubModuleTypeValue =
        VirtualMeetingEnums.MuxString;
      this.UploadRecordedOnLabel = this.$t(
        'VirtualMeetings.PreRecordedDetails.UploadedOn',
      ).toString();
    }
    Root.on('publishedOnDate', (val: any) => {
      this.publishDateE = val;
    });
    // loader off from custom category end
    Root.on('customCategoryDetailLoadingVod', (loading: boolean) => {
      this.localLinkedProgramLoading = loading ;
    });
    this.initializeTimeFormat();
    this.GetViewsCount();
    this.isAddVideoWarningVisible =
      this.localSelectedVodBaseClass.EntityId === 0 ? true : false;
    if (
      this.localSelectedVodBaseClass.VodDetail !== null &&
      this.localSelectedVodBaseClass.VodDetail !== undefined &&
      this.localSelectedVodBaseClass.VodDetail.VODLatestStatus !== null &&
      this.localSelectedVodBaseClass.VodDetail.VODLatestStatus !== ''
    ) {
      this.isVideoDetailsVisible =
        this.localSelectedVodBaseClass.VodDetail.Id > 0 ? true : false;
      this.latestVideoStatus =
        this.localSelectedVodBaseClass.VodDetail.VODLatestStatus;
      this.isCurrentUserMe =
        this.latestVideoStatus === 'VideoAssetReady' ||
        this.latestVideoStatus === 'VideoAssetUpdated' ||
        this.latestVideoStatus === 'VideoAssetErrored' ||
        this.latestVideoStatus === 'VideoAssetLiveStreamCompleted'
          ? true
          : false;
    }

    this.GetDuration();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Root.on('VodMuxVideoData', ( val: VodMuxVideoData ) => {
      const vodDetails = val ;
      if(this.selectedVodBaseClasss !== null && this.selectedVodBaseClasss !== undefined) {
        this.localSelectedVodBaseClass.EntityId =
          this.selectedVodBaseClasss.EntityId;
      }
      this.isAddVideoWarningVisible =
          this.localSelectedVodBaseClass.EntityId === 0 ? true : false;
      if (vodDetails.VideoDetails !== undefined) {
        this.localSelectedVodBaseClass.VodDetail = vodDetails.VideoDetails;
        if (vodDetails.VideoDetails !== null && vodDetails.VideoDetails !== undefined) {
          if (vodDetails.VideoDetails.Id > 0) {
            this.$emit('threshHold', false);
            // this.vonageThresholdLimitReached = false;
            if (vodDetails.VideoDetails.VodStreamingType === VodTypeEnums.Mux) {
              Root.emit(
                'set-selected-meeting-type',
                VirtualMeetingEnums.MuxString,
              );
              this.isVideoDetailsVisible = true;
              this.setDefaultDisplayDates(this);
              this.latestVideoStatus = vodDetails.VideoDetails.VODLatestStatus;
              this.isCurrentUserMe =
                vodDetails.VideoDetails.VODLatestStatus === 'VideoAssetReady' ||
                vodDetails.VideoDetails.VODLatestStatus === 'VideoAssetUpdated' ||
                vodDetails.VideoDetails.VODLatestStatus === 'VideoAssetErrored'
                  ? true
                  : false;

              if (
                this.localSelectedVodBaseClass.VodDetail.VODLatestStatus !==
                  'VideoAssetReady' &&
                this.localSelectedVodBaseClass.VodDetail.VODLatestStatus !==
                  'VideoAssetErrored'
              ) {
                Root.emit(
                  'virtual-meeting-meetapp-live-analytics-available',
                  true,
                );
              }
            }
          } else {
            this.isVideoDetailsVisible = false;
          }
        }
        this.GetViewsCount();
        this.GetDuration();
        this.isDisable = false;
        this.localLinkedProgramLoading = false;
      }
    },
    );
    Root.on('customCategoryNewAdded', () => {
      this.localSelectedVodBaseClass.EntityId = 0;
      this.isVideoDetailsVisible = false;
      this.isAddVideoWarningVisible =
        this.localSelectedVodBaseClass.EntityId === 0 ? true : false;
    });
    Root.on('program-vod-video-uploading-user-is-me', (val: boolean) => {
      this.isCurrentUserMe = val ;
    });
    Root.on(
      'entity-item-video-upload-current-status',
      (vodVideoStatus: VodSignalRStatus) => {
        const VideoDetails = vodVideoStatus ;
        this.currentWebHookEvent = VideoDetails;
        if (
          this.currentWebHookEvent !== null && this.currentWebHookEvent !== undefined && this.currentWebHookEvent.Id !== null && this.currentWebHookEvent.Id !== undefined && this.localSelectedVodBaseClass !== null && this.localSelectedVodBaseClass !== undefined && this.localSelectedVodBaseClass.VodDetail !== null && this.localSelectedVodBaseClass.VodDetail !== undefined && this.currentWebHookEvent.Id !== undefined &&
          this.currentWebHookEvent.Id ===
            this.localSelectedVodBaseClass.VodDetail.Id
        ) {
          if (
            VideoDetails.VodStatus === 'VideoUploadCreated' ||
            VideoDetails.VodStatus === 'VideoAssetCreated' ||
            VideoDetails.VodStatus === 'VideoUploadAssetCreated' ||
            VideoDetails.VodStatus === 'VideoAssetReady' ||
            VideoDetails.VodStatus === 'VideoAssetErrored'
          ) {
            this.isVideoDetailsVisible = true;
            if (this.localSelectedVodBaseClass.VodDetail === undefined) {
              this.localSelectedVodBaseClass.VodDetail =
                VodDetail.createEmpty();
            }
            this.localSelectedVodBaseClass.VodDetail.VODLatestStatus =
              VideoDetails.VodStatus;
            this.latestVideoStatus = VideoDetails.VodStatus;
            this.GetPosterUrl();
          }
        }
      },
    );
    Root.on(
      'entity-item-video-upload-current-status-api',
      (vodDetail: VodDetail) => {
        const VideoDetails = vodDetail ;
        if (VideoDetails.VODLatestStatus === 'VideoAssetReady') {
          this.isVideoDetailsVisible = true;
          if (this.localSelectedVodBaseClass.VodDetail === undefined) {
            this.localSelectedVodBaseClass.VodDetail = VodDetail.createEmpty();
          }
          this.localSelectedVodBaseClass.VodDetail = VideoDetails;
          this.latestVideoStatus = VideoDetails.VODLatestStatus;
          this.GetPosterUrl();
          this.GetDuration();
        }
      },
    );
  }
  private updated() {
    if (
      this.localSelectedVodBaseClass.SubModuleType ===
      this.virtualMeetingEnum.ProfessionalStreaming
    ) {
      this.UploadRecordedOnLabel = this.$t(
        'VirtualMeetings.RecordedOn',
      ).toString();
    } else if (
      this.localSelectedVodBaseClass.SubModuleTypeValue ===
      VirtualMeetingEnums.VonageMUX
    ) {
      // type vonageMux then showing recorded on text
      this.UploadRecordedOnLabel = this.$t(
        'VirtualMeetings.RecordedOn',
      ).toString();
    } else {
      this.UploadRecordedOnLabel = this.$t(
        'VirtualMeetings.PreRecordedDetails.UploadedOn',
      ).toString();
    }
  }
  // #region ThresholdLimits
  private GetThresholdLimitReachedMsg() {
    if (this.localSelectedVodBaseClass.SubModuleType === 3) {
      return this.$t('VirtualMeetings.MeetAppLive.TresholdLimitReached');
    } else {
      return this.$t('VirtualMeetings.PreRecordedDetails.TresholdLimitReached');
    }
  }
  // #endregion

  // #region DateBlock

  // Get UploadedOn date
  private GetUploadedOn() {
    if (
      this.localSelectedVodBaseClass.VodDetail &&
      this.localSelectedVodBaseClass.VodDetail.VodDetailApplicationInstance! &&
      this.localSelectedVodBaseClass.VodDetail.VodDetailApplicationInstance
        .UploadedOn
    ) {
      return this.formatTime(
        this.localSelectedVodBaseClass.VodDetail.VodDetailApplicationInstance.UploadedOn.toString(),
      );
    }
    return this.formatTime(new Date().toString());
  }

  // Get AvailableTillDate
  private GetAvailableTillDate() {
    const todayDate: Date = new Date();
    if (
      this.localSelectedVodBaseClass.VodDetail &&
      this.localSelectedVodBaseClass.VodDetail.VodDetailApplicationInstance !==
        null &&
      this.localSelectedVodBaseClass.VodDetail.VodDetailApplicationInstance !==
        undefined
    ) {
      const selectedate =
        this.localSelectedVodBaseClass.VodDetail.VodDetailApplicationInstance
          .StorageTillDate;
      if (
        this.localSelectedVodBaseClass.VodDetail &&
        this.localSelectedVodBaseClass.VodDetail.VodDetailApplicationInstance &&
        this.localSelectedVodBaseClass.VodDetail.VodDetailApplicationInstance
          .StorageTillDate
      ) {
        return moment(selectedate).utc().format('MMM DD, YYYY');
      }
    }
    return this.formatTime(todayDate.toString());
  }

  // set format of time according to browser
  private formatTime(date: string): string {
    if (date !== null) {
      const datepublished: Date = moment(date).toDate();
      if (!this.isIEbrowser) {
        if (this.timeZones !== null && this.timeZones !== '') {
          return moment(datepublished)
            .tz(this.timeZones)
            .format('MMM DD, YYYY');
        }
        return moment(datepublished).format('MMM DD, YYYY');
      } else {
        if (this.timeZones !== null && this.timeZones !== '') {
          return moment(datepublished).tz(this.timeZones).format('DD-MM-YYYY');
        }
        const ieDateForamt = moment(datepublished).format('DD-MM-YYYY');
        return ieDateForamt;
      }
    } else {
      return '-';
    }
  }
  //  set format of PublishedOnDate
  private formatPublishedOnDate(date: string): string {
    if (date !== null) {
      const datepublished: Date = moment(date).toDate();
      const todayDate: Date = new Date();
      const timeDiff = datepublished.getTime() - todayDate.getTime();
      const daysDifference = timeDiff / (1000 * 3600 * 24);
      if (!this.isIEbrowser) {
        if (this.timeZones !== null && this.timeZones !== '') {
          if (daysDifference > 0) {
            const DateFormat =
              this.$t('VirtualMeetings.PreRecordedDetails.Scheduled') +
              ' (' +
              moment(datepublished)
                .tz(this.timeZones)
                .format('MMM DD, YYYY, hh:mm A') +
              ')';
            return DateFormat;
          } else {
            const DateForamt = moment(datepublished)
              .tz(this.timeZones)
              .format('MMM DD, YYYY, hh:mm A');
            return DateForamt;
          }
        } else {
          if (daysDifference > 0) {
            const DateFormat =
              this.$t('VirtualMeetings.PreRecordedDetails.Scheduled') +
              ' (' +
              moment(datepublished).format('MMM DD, YYYY, hh:mm A') +
              ')';
            return DateFormat;
          } else {
            const DateForamt = moment(datepublished).format(
              'MMM DD, YYYY, hh:mm A',
            );
            return DateForamt;
          }
        }
      } else {
        if (this.timeZones !== null && this.timeZones !== '') {
          return moment(datepublished).tz(this.timeZones).format('DD-MM-YYYY');
        }
        return moment(datepublished).format('DD-MM-YYYY');
      }
    } else {
      return '-';
    }
  }
  // format PublishedOnDateNew
  private formatPublishedOnDateNew(obj: any): string {
    if (obj.PublishOption === 1) {
      return this.formatPublishedOnDate(String(obj.PublishDate));
    } else {
      return this.formatPublishedOnDate(String(obj.PublishUTCDate));
    }
  }

  // Initialize and set time format according to browser and timezone
  private initializeTimeFormat() {
    const browsersettings: BrowserSettingsInfo =
      this.storeHelper.GetBrowserSettingsFromStore();
    if (this.timeZones !== '' && this.timeZones !== null && !this.isIEbrowser) {
      this.dateFormat = new Intl.DateTimeFormat(browsersettings.locale, {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        timeZone: this.timeZones,
      });
    } else {
      this.dateFormat = new Intl.DateTimeFormat(browsersettings.locale, {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
      });
    }
  }

  // set DefaultDisplayDates
  private setDefaultDisplayDates(self: any) {
    if (self.localSelectedVodBaseClass !== null &&
    self.localSelectedVodBaseClass !== undefined &&
      self.localSelectedVodBaseClass!.VodDetail! !== null &&
      self.localSelectedVodBaseClass!.VodDetail! !== undefined &&
      self.localSelectedVodBaseClass!.VodDetail!
        .VodDetailApplicationInstance! !== null &&
      self.localSelectedVodBaseClass!.VodDetail!
        .VodDetailApplicationInstance! !== undefined &&
      self.localSelectedVodBaseClass!.VodDetail!.VodDetailApplicationInstance!
        .PublishUTCDate !== null &&
      self.localSelectedVodBaseClass!.VodDetail!.VodDetailApplicationInstance!
        .PublishUTCDate !== undefined
    ) {
      self.publishDateE =
        self.localSelectedVodBaseClass!.VodDetail!.VodDetailApplicationInstance!.PublishUTCDate;
    }
  }

  // #endregion

  // #region VideoBlock
  // show VideoDuration
  private showVideoDuration(VideoDuration: string) {
    const d = Number(VideoDuration);
    const h = Math.floor(d / 3600);
    const m = Math.floor((d % 3600) / 60);
    const s = Math.floor((d % 3600) % 60);
    if (h > 0) {
      return h + ':' + m + ':' + s;
    }
    return m + ':' + s;
  }
  // Show AddVideo component
  private ShowAddVideo() {
    Root.emit('show-add-video-section-byEntity', true);
    Root.emit(
      'show-add-video-section-vod-byEntity',
      this.localSelectedVodBaseClass.SubModuleType,
    );
  }
  // Retry to add video
  private TryAgain() {
    if (this.localSelectedVodBaseClass.VodDetail.Id) {
      // Delete video API call
      FetchData('/' +
            this.localSelectedVodBaseClass.Moduletype +
            '/DeleteVideoByVodDetailid',
      JSON.stringify({
        vodDetailId: this.localSelectedVodBaseClass.VodDetail.Id,
      }))
        .then((response) => {
          if (response.success === 'true') {
            Root.emit('show-add-video-section-byEntity', true);
          }
        });
    } else {
      Root.emit('show-add-video-section-byEntity', true);
    }
  }
  // PlayVideo show video player
  private PlayVideo() {
    this.videoPlayerVisible = true;
  }
  // Close Player hide video player
  private ClosePlayer() {
    this.videoPlayerVisible = false;
  }
  // Get duration of video
  private GetDuration() {
    if (
      this.localSelectedVodBaseClass.VodDetail !== null &&
      this.localSelectedVodBaseClass.VodDetail !== undefined &&
      this.localSelectedVodBaseClass.VodDetail.VodVideoDetail !== null &&
      this.localSelectedVodBaseClass.VodDetail.VodVideoDetail !== undefined
    ) {
      this.videoDurationNumber =
        this.localSelectedVodBaseClass.VodDetail.VodVideoDetail.Duration!;
      this.videoDuration = this.showVideoDuration(this.videoDurationNumber);
    }
  }

  // Get PosterUrl of video
  private GetPosterUrl() {
    // Set appropriate image corresponding to status of video upload.
    if (
      this.localSelectedVodBaseClass.VodDetail !== null &&
      this.localSelectedVodBaseClass.VodDetail !== undefined
    ) {
      if (
        this.localSelectedVodBaseClass.VodDetail.VODLatestStatus ===
        'VideoUploadCreated'
      ) {
        return this.uploadingImage;
      } else if (
        this.localSelectedVodBaseClass.VodDetail.VODLatestStatus ===
        'VideoAssetCreated'
      ) {
        this.isVideoToBePlayed = true;
        return this.processingImage;
      } else if (
        this.localSelectedVodBaseClass.VodDetail.VODLatestStatus ===
        'VideoAssetErrored'
      ) {
        return this.ErrorImage;
      } else if (
        this.localSelectedVodBaseClass.VodDetail.VODLatestStatus ===
        'VideoAssetDeleted'
      ) {
        this.isVideoToBePlayed = true;
        return this.DeletedImage;
      } else {
        if (
          this.localSelectedVodBaseClass.SubModuleType ===
            this.virtualMeetingEnum.MeetAppLive &&
          this.localSelectedVodBaseClass.VodDetail.IsDeleted === true
        ) {
          this.isVideoToBePlayed = true;
          return this.DeletedImage;
        } else if (
          this.localSelectedVodBaseClass.VodDetail.VodVideoDetail !== null &&
          this.localSelectedVodBaseClass.VodDetail.VodVideoDetail !== undefined
        ) {
          return this.localSelectedVodBaseClass.VodDetail.VodVideoDetail
            .PosterUrl;
        } else {
          return this.noThumbnailImage;
        }
      }
    } else {
      return this.missingImage;
    }
  }

  // Delete Video Click
  private DeleteVideoClick() {
    // Show warning on video upload clicked.
    if (
      this.localSelectedVodBaseClass.VodDetail !== null &&
      this.localSelectedVodBaseClass.VodDetail !== undefined
    ) {
      if (
        this.localSelectedVodBaseClass.VodDetail.VodStreamingType ===
          VodTypeEnums.Mux &&
        this.localSelectedVodBaseClass.SubModuleType ===
          this.virtualMeetingEnum.MeetAppLive
      ) {
        this.showSectionModalPopup = this.VonageMUXDeleteVideo;
      } else if (
        this.localSelectedVodBaseClass.VodDetail.VodStreamingType ===
        VodTypeEnums.Mux
      ) {
        this.showSectionModalPopup = this.VodDeleteVideo;
      } else if (
        this.localSelectedVodBaseClass.VodDetail.VodStreamingType ===
        VodTypeEnums.RTMP
      ) {
        this.showSectionModalPopup = this.RtmpDeleteVideo;
      }
    }
    this.modalPopupHeader = this.$t('DeleteVideo').toString();
    this.modalPopupContent = this.$t(
      'VirtualMeetings.AddVideo.DeleteVideoWarning',
    ).toString();
    this.modalPopupConfirmButtonText = this.$t('Button.Delete').toString();
    this.modalPopupVisible = true;
  }
  // Delete Video api hit
  private DeleteVideo(
    detailApplicationInstanceId: number,
    detailId: number,
    selectedEntityId: number,
  ) {
    const signalObject = this.SendNotificationRequest();
    // Delete video API call and set path according to module type
    FetchData('/' + this.localSelectedVodBaseClass.Moduletype + '/DeleteVideo',
      JSON.stringify({
        vodDetailId: detailId,
        vodDetailApplicationInstanceId: detailApplicationInstanceId,
        entityId: selectedEntityId,
        entityType: this.localSelectedVodBaseClass.Moduletype,
      }))
      .then((response) => {
        if (response.success === 'true') {
          this.localSelectedVodBaseClass.VodDetail = VodDetail.createEmpty();
          Root.emit('reload-VodDetail-delete');
          Root.emit('reload-VodDetail-delete-program');
          this.isVideoDetailsVisible = false;
          this.SendNotificationRequestToQueue(signalObject);
        }
      });
  }
  // DeleteStreamVideo
  private DeleteStreamVideo(
    selectedEntityId: number,
    detailId: number,
    StreamType: string,
  ) {
    let signalObject: SignalRModelRequest;
    // delete rtmp and vonageMUX (Ventla live)
    if(this.localSelectedVodBaseClass.Moduletype !== 'Entity') {
      signalObject = this.SendNotificationRequest();
    }
    // Delete video API call
    FetchData('/' +
            (this.localSelectedVodBaseClass.Moduletype === 'Entity' ? 'ApplicationInstance' : this.localSelectedVodBaseClass.Moduletype) +
          '/DeleteLiveVideoStream',
    JSON.stringify({
      programId: selectedEntityId,
      vodDetailId: detailId,
      streamType: StreamType,
    }))
      .then((response) => {
        if (response.status === true) {
          if (StreamType === 'VonageMUX') {
            Root.emit('reload-program-detail');
            Root.emit('reload-watchlivedelete-detail',response.status);
            this.isVideoDetailsVisible = true;
            this.localSelectedVodBaseClass.VodDetail.VODLatestStatus = 'VideoAssetDeleted';
            this.latestVideoStatus = 'VideoAssetDeleted';
          } else {
            this.localSelectedVodBaseClass.VodDetail = VodDetail.createEmpty();
            Root.emit('reload-program-detail');
            Root.emit('reload-VodDetail-delete-program');
            this.isVideoDetailsVisible = true;
            Root.emit(
              'virtual-meeting-meetapp-live-analytics-available',
              true,
            );
            //  Root.emit('set-rtmp-to-Active', true);
          }
          if(this.localSelectedVodBaseClass.Moduletype !== 'Entity') {
            this.SendNotificationRequestToQueue(signalObject);
          }
        }
      });
  }

  // #endregion

  // #region SignalR

  // SendNotificationRequest
  private SendNotificationRequest(): SignalRModelRequest {
    let signalR: any;
    // eslint-disable-next-line prefer-const
    signalR = this.GetSignalRObjectByEntityType(
      this.localSelectedVodBaseClass.Moduletype,
      signalR,
    );

    let signalObject: SignalRModelRequest = new SignalRModelRequest();
    if (
      this.localSelectedVodBaseClass.Moduletype ===
      VodModuleTypeEnum[1].toString()
    ) {
      signalObject = signalR.SingleVodVideoDeleteSignalRModelRequest;
    } else {
      signalObject = signalR.SingleVodVideoDeleteSignalRModelRequest;
    }

    signalObject = signalR.SingleVodVideoDeleteSignalRModelRequest;
    const arr: number[] = [];
    arr.push(this.localSelectedVodBaseClass.EntityId);
    signalObject.SelectedIds = arr;
    signalObject.Description = this.$t(signalObject.SubmitMessage, {
      selectedCount: arr.length, // Just single item delete
      user: signalR.GetUserName(
        signalObject,
        this.$t('UserName.You').toString(),
      ),
    }).toString();
    const storeHelper: StoreHelper = new StoreHelper(Store);
    const reqInfo: AppRequestInfo = storeHelper.GetRequestInfoFromStore();
    signalObject.ApplicationId = Number(reqInfo.ApplicationId);
    signalObject.EventId = Number(reqInfo.ApplicationInstanceId);
    signalObject.JSONData = JSON.stringify({
      selectedName: this.localSelectedVodBaseClass.Title,
    });
    return signalObject;
  }
  // Get SignalR Object By EntityType
  private GetSignalRObjectByEntityType(entityType: string, signalR: any) {
    switch (entityType) {
    case VodModuleTypeEnum[1].toString():
      signalR = new CustomCategorySignalRModel(
        Root,
        Store,
        this.$t,
      );
      break;
    case VodModuleTypeEnum[0].toString():
      signalR = new ProgramSignalRModel(
        Root,
        Store,
        this.$t,
      );
      break;
    }
    return signalR;
  }
  // Send Notification Request To Queue
  private SendNotificationRequestToQueue(signalObject: SignalRModelRequest) {
    let signalR: any;
    // eslint-disable-next-line prefer-const
    signalR = this.GetSignalRObjectByEntityType(
      this.localSelectedVodBaseClass.Moduletype,
      signalR,
    );
    if (signalObject.SelectedIds.length === 0) {
      const arr: number[] = [];
      arr.push(this.localSelectedVodBaseClass.EntityId);
      signalObject.SelectedIds = arr;
    }
    switch (this.localSelectedVodBaseClass.Moduletype) {
    case VodModuleTypeEnum[1].toString():
      signalR.PerformCustomCategorySingleOperation(signalObject);
      break;
    case VodModuleTypeEnum[0].toString():
      signalR.PerformProgramSingleOperation(signalObject);
      break;
    }
  }

  // #endregion

  // #region Analytics

  // see DetailedAnalytics
  private seeDetailedAnalytics() {
    Root.emit('show-pre-recorded-video-analytics-section', true);
  }

  // Get ViewsCount of video
  private GetViewsCount() {
    if (
      this.localSelectedVodBaseClass !== null &&
      this.localSelectedVodBaseClass !== undefined &&
      this.localSelectedVodBaseClass.VodDetail !== undefined &&
      this.localSelectedVodBaseClass.VodDetail !== null &&
      this.localSelectedVodBaseClass.VodDetail.VodVideoAnalytics !==
        undefined &&
      this.localSelectedVodBaseClass.VodDetail.VodVideoAnalytics !== null &&
      this.localSelectedVodBaseClass.VodDetail.VodVideoAnalytics
        .TotalTimesWatched !== undefined &&
      this.localSelectedVodBaseClass.VodDetail.VodVideoAnalytics
        .TotalTimesWatched !== null
    ) {
      this.localViewCount =
        this.localSelectedVodBaseClass.VodDetail.VodVideoAnalytics.TotalTimesRecordingWatched!;
    } else {
      this.localViewCount = 0;
    }
  }
  // #endregion

  // #region HTML

  // get Information String value
  private getInformationString(val: boolean) {
    this.isActive = val;
  }

  // show loader
  private showLoader(): boolean {
    if (this.localLinkedProgramLoading && this.moduleType !== 'Program' && this.moduleType !== 'Entity') {
      return true;
    }
    return false;
  }

  // #endregion

  // ConfirmClick from model popup for delete video
  private ConfirmClick(confirmed: boolean) {
    this.modalPopupVisible = false;
    if (confirmed) {
      // check type of video / submodule
      if (this.showSectionModalPopup === this.VodDeleteVideo) {
        this.DeleteVideo(
          this.localSelectedVodBaseClass.VodDetail.VodDetailApplicationInstance!
            .Id,
          this.localSelectedVodBaseClass.VodDetail.Id,
          this.localSelectedVodBaseClass.EntityId,
        );
      } else if (this.showSectionModalPopup === this.RtmpDeleteVideo) {
        this.DeleteStreamVideo(
          this.localSelectedVodBaseClass.EntityId,
          this.localSelectedVodBaseClass.VodDetail.Id,
          'RTMP',
        );
      } else if (this.showSectionModalPopup === this.VonageMUXDeleteVideo) {
        this.DeleteStreamVideo(
          this.localSelectedVodBaseClass.EntityId,
          this.localSelectedVodBaseClass.VodDetail.Id,
          'VonageMUX',
        );
      } else {
        return;
      }
    }
  }

  // #region Watcher

  // Watch localSelectedVodBaseClass change
  @Watch('localSelectedVodBaseClass')
  private onlocalSelectedVodBaseClassChange(val: VodBaseRenderModel) {
    if(val.Moduletype === VodModuleTypeEnum[VodModuleTypeEnum.Program].toString()) {
      if (val.VodDetail !==  undefined &&  val.VodDetail.Id > 0) {
        this.isVideoDetailsVisible = true;
      } else {
        this.isVideoDetailsVisible = false;
      }
      if(val.VodDetail !==  null && val.VodDetail !==  undefined) {
        if(val.VodDetail.VodVideoDetail !== null && val.VodDetail.VodVideoDetail !== undefined) {
          this.latestVideoStatus = val.VodDetail.VODLatestStatus;
          this.videoDuration = this.showVideoDuration(val.VodDetail.VodVideoDetail.Duration);
        }
        if(val.VodDetail.VodDetailApplicationInstance !== null && val.VodDetail.VodDetailApplicationInstance !== undefined) {
          this.publishDateE = val.VodDetail.VodDetailApplicationInstance.PublishUTCDate;
        }
      }
    }
    Root.emit('set-vod-base-renderer', this.localSelectedVodBaseClass);
  }

  // Watch selectedVodBaseClass change
  @Watch('selectedVodBaseClasss')
  private onSelectedVodBaseClassChange(val: VodBaseRenderModel) {
    if (val.VodDetail !== undefined) {
      // set changed object in local object
      this.localSelectedVodBaseClass = val;
    }
    // set module type in local var for show sections according to type
    this.moduleType = this.selectedVodBaseClasss!.Moduletype;
  }
  // #endregion
}
export default toNative(VideoOnDemandComponent);
